import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useAddToCustomerBagMutation,
  useAddToWishlistMutation,
  useGetProductsMutationMutation,
  useGetProductsQuery,
  useRemoveFromCustomerBagMutation,
  useRemoveFromWishlistMutation,
} from "../../../redux/slices/homeSlice";
import { Bounce, toast } from "react-toastify";
import "./Category.scss";
import "../../../auth/LoginSignup.scss";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";
import { addToMyBag } from "../../../redux/slices/myBagSlice";
import LOADER from "../../Master/LOADER";
import { FilterSidePanel } from "./FilterSidePanel";
import Skeleton from "react-loading-skeleton";
import { fakeData } from "../../../json";
import LazyImageLoader from "../../Master/LazyImageLoader";
import MODEL from "../../Master/MODEL";
import Masonry from "react-masonry-css";

import {
  CLOSE_BLACK_IC,
  homeBannerDesktop,
  mainBgImg,
  THREE_CATEGORY_IC,
  TWO_CATEGORY_IC,
  single_grid_off_IC,
  single_grid_on_IC,
  double_grid_off_IC,
  double_grid_on_IC,
  triple_grid_off_IC,
  triple_grid_on_IC,
  dagabengalurulogoPNG,
  ONE_CATEGORY_IC,
  FOUR_CATEGORY_IC,
  FIVE_CATEGORY_IC,
} from "../../../assets";
import BTN from "../../Master/BTN";
import { Login } from "../../../auth/Login";
import { Signup } from "../../../auth/Signup";
import ReactImageMagnify from "react-image-magnify";
function Category() {
  const params = useParams();
  const location = useLocation();
  const category = params?.name;

  const [showFilter, setShowFilter] = useState(false);
  const showFilterHandler = () => {
    setShowFilter(!showFilter);
  };
  const [sortBy, setSortBy] = useState({});
  const [totalDocs, setTotalDocs] = useState(0);
  const [attributeFilters, setAttributeFilters] = useState({});
  const [isEqualGrid, setIsEqualGrid] = useState(true);
  // const [gridCount, setGridCount] = useState(width > 900 ? 5 : 2);
  const [isOneGrid, setIsOneGrid] = useState(false);
  const [selectedTab, setSelectedTab] = useState("login");
  const [stockvalue, setStockValue] = useState("all");

  const [width, setWidth] = useState(window.innerWidth);
  const getDefaultGridCount = (w) => (w >= 1024 ? 5 : w >= 468 ? 4 : 1);
  const [gridCount, setGridCount] = useState(getDefaultGridCount(width));
  const [userSelectedGrid, setUserSelectedGrid] = useState(false); // Track manual selection

  // useEffect(() => {
  //   const handleResize = () => {
  //     const newWidth = window.innerWidth;
  //     setWidth(newWidth);
  //     setGridCount(getDefaultGridCount(newWidth));
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);

      if (!userSelectedGrid) {
        setGridCount(getDefaultGridCount(newWidth)); // Only update if user hasn't manually set
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [userSelectedGrid]);

  const handleGridChange = (count) => {
    setGridCount(count);
    setUserSelectedGrid(true); // Mark manual selection
  };

  // useEffect(() => {
  //   if (!isEqualGrid && gridCount === 1 && width < 600) {
  //     setGridCount(2);
  //   }
  // }, [isEqualGrid, gridCount]);

  return (
    <div className="categories">
      <div className="d-flex j-sb filter-nav">
        <div className="sort-filter-btn text-primary lato-regular flex flex-col md:flex-row items-start md:items-center">
          <span onClick={showFilterHandler}>SORT AND FILTER</span>
          {/* <div className="ms-0 md:ms-5 mt-1 md:mt-0">
            <label class="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                value=""
                class="sr-only peer"
                onChange={(e) => setIsEqualGrid(e.target.checked)}
              />
              <div class="relative w-11 h-6 bg-[#5d0d1968] rounded-full peer peer-focus:ring-4 peer-focus:ring-primary dark:peer-focus:ring-primary dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary dark:peer-checked:bg-primary"></div>
              <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                Equal Grid
              </span>
            </label>
          </div> */}
        </div>
        <div className="flex justify-center items-center">
          {isEqualGrid && (
            <div
              className="w-[24px] cursor-pointer flex justify-center items-center"
              onClick={() => handleGridChange(1)}
            >
              <img
                src={ONE_CATEGORY_IC}
                alt=""
                className={`cursor-pointer ${
                  gridCount === 1 ? "bg-opacity-10 bg-primary" : ""
                }`}
              />
            </div>
          )}
          <div
            className="w-[24px] cursor-pointer flex md:hidden justify-center items-center ms-1"
            onClick={() => handleGridChange(2)}
          >
            <img
              src={TWO_CATEGORY_IC}
              alt=""
              className={`flex md:hidden cursor-pointer ${
                gridCount === 2 ? "bg-opacity-10 bg-primary" : ""
              }`}
            />
          </div>
          <img
            onClick={() => handleGridChange(3)}
            src={THREE_CATEGORY_IC}
            alt=""
            className={`hidden sm:flex cursor-pointer ${
              gridCount === 3 ? "bg-opacity-10 bg-primary" : ""
            } ms-1`}
          />
          <img
            onClick={() => handleGridChange(4)}
            src={FOUR_CATEGORY_IC}
            alt=""
            className={`hidden md:flex cursor-pointer ${
              gridCount === 4 ? "bg-opacity-10 bg-primary" : ""
            } ms-3`}
          />
          <img
            onClick={() => handleGridChange(5)}
            src={FIVE_CATEGORY_IC}
            alt=""
            className={`hidden md:flex cursor-pointer ${
              gridCount === 5 ? "bg-opacity-10 bg-primary" : ""
            } ms-3`}
          />
        </div>
      </div>
      <FilterSidePanel
        showFilter={showFilter}
        showFilterHandler={showFilterHandler}
        category={category}
        setSortBy={setSortBy}
        totalDocs={totalDocs}
        setAttributeFilters={setAttributeFilters}
        setStockValue={setStockValue}
      />
      <div className="category-grid">
        <VirtualProducts
          category={category}
          sortBy={sortBy}
          isEqualGrid={isEqualGrid}
          setTotalDocs={setTotalDocs}
          attributeFilters={attributeFilters}
          gridCount={gridCount}
          setGridCount={setGridCount}
          setIsOneGrid={setIsOneGrid}
          stockvalue={stockvalue}
          screenWidth={width}
        />
      </div>
      {/* {!localStorage.getItem("user") && (
        <div className="loginSignup pt-4">
          <div className="w-full flex flex-col items-center">
            <div className="lg:hidden emd:flex small:flex items-center justify-center mb-2">
              <span
                onClick={() => setSelectedTab("login")}
                className={` ${
                  selectedTab === "login"
                    ? "text-primary underline underline-offset-8"
                    : "text-text_dark_3"
                } select-none cursor-pointer text-xl`}
              >
                Login
              </span>
              <span
                onClick={() => setSelectedTab("signup")}
                className={` ${
                  selectedTab === "signup"
                    ? "text-primary underline underline-offset-8"
                    : "text-text_dark_3"
                } select-none cursor-pointer ms-4 text-xl`}
              >
                Signup
              </span>
            </div>
            <div className="main-box w-full lg:flex emd:hidden small:hidden justify-center items-start bg-text_light_2 px-[15%] pt-10 pb-28">
              <div className="login-box lg_login border-r-2 border-primary">
                <Login />
              </div>
              <div className="signup-box">
                <Signup />
              </div>
            </div>
            <div className="main-box w-full lg:hidden emd:flex small:flex justify-center items-start px-[4%] lm:px-[15%] pt-4 pb-28">
              {selectedTab === "login" ? (
                <div className="login-box">
                  <Login />
                </div>
              ) : (
                <div className="signup-box">
                  <Signup />
                </div>
              )}
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export const ProductCard = (props) => {
  const user = useGetUser();
  const { pathname } = useLocation();
  const imageUrl = props.product?.image[0]?.replace(
    "upload/",
    "upload/f_auto/fl_progressive/if_w_gt_1000/w_1000/if_end/"
  );

  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    if (user?.customer) {
      setLoggedIn(true);
    }
  }, [user]);
  const [wishListed, setWishListed] = useState(false);
  const wishlistData = useSelector((state) => state.wishlist.data);

  useEffect(() => {
    if (wishlistData) {
      if (props?.product._id) {
        const found = wishlistData?.find(
          (element) => element._id === props.product._id
        );
        if (found) {
          setWishListed(true);
        } else {
          setWishListed(false);
        }
      }
    }
  }, [wishlistData, props]);

  const [addToWishlist] = useAddToWishlistMutation();
  const [removeFromWishlist] = useRemoveFromWishlistMutation();
  const handleWishlist = () => {
    if (!wishListed) {
      if (!loggedIn) {
        toast.error("Please log in to add into Wishlist");
        return;
      }
      if (!props.product._id) {
        return;
      }
      addToWishlist({
        body: {
          product_id: props.product._id,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res.data) {
          setWishListed(true);
          toast.success("Added to Wishlist");
        }
        if (res.error) {
          toast.error(res.error.data.message);
        }
      });
    } else {
      removeFromWishlist({
        body: {
          product_id: props.product._id,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res.data) {
          setWishListed(false);
          toast.success("Removed from Wishlist");
        }
        if (res.error) {
          toast.error(res.error.data.message);
        }
      });
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const stock = 10;

  const redirctUrl = `/products/${props?.product?._id}`;
  var image = null;

  image = props.product?.image[0] ? props.product?.image[0] : null;
  if (image) {
    var transformedImage = image.replace(
      "upload/",
      "upload/if_w_gt_400/w_400/if_end/"
    );
  }
  //on click on sku copy the sku to clipboard
  const copyToClipboard = (e) => {
    navigator.clipboard.writeText(props.product.sku);
    e.target.innerText = "Copied!";
    setTimeout(() => {
      e.target.innerText = "SKU : " + props.product.sku;
    }, 1000);
  };

  // ====================== ADD TO BAG HANDLE ================================

  const [addToCustomerBag] = useAddToCustomerBagMutation();

  const addToMyBagHandel = () => {
    if (loggedIn) {
      addToCustomerBag({
        body: {
          products: [
            {
              product_id: props?.product?._id,
              quantity: 1,
              variant: [],
              lens: [],
            },
          ],
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          toast.success(`${props?.product?.name} added to bag successfully.`);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    } else {
      dispatch(addToMyBag(props?.product));
      toast.success(`${props?.product?.name} added to bag successfully.`);
    }
  };

  // ====================== New arrival ================================
  const [showNewArrival, setShowNewArrival] = useState(false);
  const interval = 1000 * 60 * 60 * 24 * 30; // 30 days
  useEffect(() => {
    if (props?.product?.createdAt) {
      const productDate = new Date(props?.product?.createdAt);
      const currentDate = new Date();
      const diff = currentDate - productDate;
      if (diff < interval) {
        setShowNewArrival(true);
      }
    }
  }, [props?.product?.createdAt]);

  // =================== ADD CART HANDLE =================

  const addCartHandle = (isAddLens) => {
    if (isAddLens) {
      navigate(user?.customer ? "/lens" : "/login", {
        state: { id: props?.product?._id },
      });
    } else {
      addToMyBagHandel();
    }
  };

  return (
    <>
      <div
        key={props?.product?._id}
        className={` ${
          props?.gridCount === 1 ? "flex-row items-start" : "flex-col"
        } card w-full h-fit flex bg-text_light_3 rounded-[20px] mb-5 `}
      >
        <div className="w-full h-fit rounded-[20px] cursor-pointer relative">
          <div
            className="w-full h-fit object-cover rounded-[20px] cursor-pointer relative"
            onClick={() =>
              !pathname?.includes("exchange-order")
                ? window.open(`${redirctUrl}`, "_blank")
                : null
            }
          >
            <LazyImageLoader
              skeletonHeight={`20vh`}
              imgSrc={imageUrl || dagabengalurulogoPNG}
              imgAlt="product image"
              // imgClassName={` ${
              //   props?.isEqualGrid ? "max-h-[40vh] aspect-square" : ""
              // } rounded-[20px] w-full transition-all duration-300`}
              imgClassName={`rounded-[20px] w-full transition-all duration-300`}
            />
          </div>
          <div className="w-full top-2 absolute flex items-center justify-between">
            {/* {props?.product?.stock > 0 && (
              <div
                style={{ visibility: showNewArrival ? "visible" : "hidden" }}
                className="-ms-1 lato-regular new-arrival-label bg-primary  text-white px-4 py-1"
              >
                &nbsp; NEW ARRIVAL &nbsp;
              </div>
            )} */}

            {props?.product?.stock <= 0 && (
              <div className="-ms-1 lato-regular new-arrival-label bg-text_dark_3  text-white px-4 py-1">
                &nbsp;MAKE TO ORDER&nbsp;
              </div>
            )}

            {props?.gridCount !== 1 && (
              <div>
                {/* {wishListed ? (
                <svg
                  onClick={handleWishlist}
                  className="pointer me-2 filled p-1 rounded-full bg-white min-w-[35px] max-w-[35px] min-h-[35px] max-h-[35px]"
                  viewBox="0 -960 960 960"
                  fill="#5D0D19"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="min-w-fit max-w-fit min-h-fit max-h-fit"
                    d="M 480 -173.85 L 449.69 -201.23 C 384.41 -260.87 330.41 -311.92 287.69 -354.38 C 244.977 -396.847 211.26 -434.297 186.54 -466.73 C 161.82 -499.163 144.55 -528.51 134.73 -554.77 C 124.91 -581.023 120 -607.433 120 -634 C 120 -684.873 137.283 -727.59 171.85 -762.15 C 206.41 -796.717 249.127 -814 300 -814 C 335.18 -814 368.18 -805 399 -787 C 429.82 -769 456.82 -742.82 480 -708.46 C 503.18 -742.82 530.18 -769 561 -787 C 591.82 -805 624.82 -814 660 -814 C 710.873 -814 753.59 -796.717 788.15 -762.15 C 822.717 -727.59 840 -684.873 840 -634 C 840 -607.433 835.09 -581.023 825.27 -554.77 C 815.45 -528.51 798.18 -499.163 773.46 -466.73 C 748.74 -434.297 715.15 -396.847 672.69 -354.38 C 630.23 -311.92 576.103 -260.87 510.31 -201.23 L 480 -173.85 Z M 480 -501 Z"
                    transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
                  />
                </svg>
              ) : (
                <svg
                  onClick={handleWishlist}
                  className="pointer bg-white p-1 rounded-full me-2 min-w-[35px] max-w-[35px] min-h-[35px] max-h-[35px]"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#5D0D19"
                >
                  <path
                    className="min-w-fit max-w-fit min-h-fit max-h-fit"
                    d="m480-173.85-30.31-27.38q-97.92-89.46-162-153.15-64.07-63.7-101.15-112.35-37.08-48.65-51.81-88.04Q120-594.15 120-634q0-76.31 51.85-128.15Q223.69-814 300-814q52.77 0 99 27t81 78.54Q514.77-760 561-787q46.23-27 99-27 76.31 0 128.15 51.85Q840-710.31 840-634q0 39.85-14.73 79.23-14.73 39.39-51.81 88.04-37.08 48.65-100.77 112.35Q609-290.69 510.31-201.23L480-173.85Zm0-54.15q96-86.77 158-148.65 62-61.89 98-107.39t50-80.61q14-35.12 14-69.35 0-60-40-100t-100-40q-47.77 0-88.15 27.27-40.39 27.27-72.31 82.11h-39.08q-32.69-55.61-72.69-82.5Q347.77-774 300-774q-59.23 0-99.62 40Q160-694 160-634q0 34.23 14 69.35 14 35.11 50 80.61t98 107q62 61.5 158 149.04Zm0-273Z"
                  />
                </svg>
              )} */}
              </div>
            )}
            {props.product?.quantity > 0 && (
              <div
                className={
                  location.pathname === "/inventory" &&
                  props.storeType === "In Store"
                    ? "count"
                    : "count hide"
                }
              >
                {props.product?.quantity}
              </div>
            )}
          </div>
        </div>
        <div className="w-full p-5">
          <div className="bottom">
            {props?.gridCount === 1 && (
              <div className="absolute right-2 top-2">
                {/* {wishListed ? (
                <svg
                  onClick={handleWishlist}
                  className="pointer me-2 filled p-1 rounded-full bg-white min-w-[24px] max-w-[24px] min-h-[24px] max-h-[24px] md:min-w-[35px] md:max-w-[35px] md:min-h-[35px] md:max-h-[35px]"
                  viewBox="0 -960 960 960"
                  fill="#5D0D19"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="min-w-fit max-w-fit min-h-fit max-h-fit"
                    d="M 480 -173.85 L 449.69 -201.23 C 384.41 -260.87 330.41 -311.92 287.69 -354.38 C 244.977 -396.847 211.26 -434.297 186.54 -466.73 C 161.82 -499.163 144.55 -528.51 134.73 -554.77 C 124.91 -581.023 120 -607.433 120 -634 C 120 -684.873 137.283 -727.59 171.85 -762.15 C 206.41 -796.717 249.127 -814 300 -814 C 335.18 -814 368.18 -805 399 -787 C 429.82 -769 456.82 -742.82 480 -708.46 C 503.18 -742.82 530.18 -769 561 -787 C 591.82 -805 624.82 -814 660 -814 C 710.873 -814 753.59 -796.717 788.15 -762.15 C 822.717 -727.59 840 -684.873 840 -634 C 840 -607.433 835.09 -581.023 825.27 -554.77 C 815.45 -528.51 798.18 -499.163 773.46 -466.73 C 748.74 -434.297 715.15 -396.847 672.69 -354.38 C 630.23 -311.92 576.103 -260.87 510.31 -201.23 L 480 -173.85 Z M 480 -501 Z"
                    transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
                  />
                </svg>
              ) : (
                <svg
                  onClick={handleWishlist}
                  className="pointer bg-white p-1 rounded-full me-2 min-w-[24px] max-w-[24px] min-h-[24px] max-h-[24px] md:min-w-[35px] md:max-w-[35px] md:min-h-[35px] md:max-h-[35px]"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#5D0D19"
                >
                  <path
                    className="min-w-fit max-w-fit min-h-fit max-h-fit"
                    d="m480-173.85-30.31-27.38q-97.92-89.46-162-153.15-64.07-63.7-101.15-112.35-37.08-48.65-51.81-88.04Q120-594.15 120-634q0-76.31 51.85-128.15Q223.69-814 300-814q52.77 0 99 27t81 78.54Q514.77-760 561-787q46.23-27 99-27 76.31 0 128.15 51.85Q840-710.31 840-634q0 39.85-14.73 79.23-14.73 39.39-51.81 88.04-37.08 48.65-100.77 112.35Q609-290.69 510.31-201.23L480-173.85Zm0-54.15q96-86.77 158-148.65 62-61.89 98-107.39t50-80.61q14-35.12 14-69.35 0-60-40-100t-100-40q-47.77 0-88.15 27.27-40.39 27.27-72.31 82.11h-39.08q-32.69-55.61-72.69-82.5Q347.77-774 300-774q-59.23 0-99.62 40Q160-694 160-634q0 34.23 14 69.35 14 35.11 50 80.61t98 107q62 61.5 158 149.04Zm0-273Z"
                  />
                </svg>
              )} */}
              </div>
            )}
            <div className="cursor-pointer text-text_dark_3 text-lg w-[calc(100%)] overflow-hidden whitespace-nowrap text-ellipsis text capitalize">
              {props.product?.name ? (
                <span
                  onClick={() =>
                    !pathname?.includes("exchange-order")
                      ? window.open(`${redirctUrl}`, "_blank")
                      : null
                  }
                  className="lato-medium"
                >
                  {props.product?.name}
                </span>
              ) : (
                <Skeleton className="h-full" />
              )}
            </div>
            {props?.product?.netWeight !== 0 && (
              <div
                onClick={() =>
                  !pathname?.includes("exchange-order")
                    ? window.open(`${redirctUrl}`, "_blank")
                    : null
                }
                className="text-sm lato-regular cursor-pointer"
              >
                Net&nbsp;wt:&nbsp;{props?.product?.netWeight}&nbsp;g
              </div>
            )}
            {props?.product?.grossWeight !== 0 && (
              <div
                onClick={() =>
                  !pathname?.includes("exchange-order")
                    ? window.open(`${redirctUrl}`, "_blank")
                    : null
                }
                className="text-sm lato-regular cursor-pointer"
              >
                Gross&nbsp;wt:&nbsp;{props?.product?.grossWeight}&nbsp;g
              </div>
            )}
            {/* <span
            className="add_to_bag_text text-primary cursor-pointer lato-regular uppercase underline"
            onClick={() => addCartHandle(false)}
          >
            Add to Bag
          </span> */}
          </div>
          {props.product?.quantity === 0 ||
            props.product?.quantity === "0" ||
            (Number(props.product?.quantity) <= 0 && (
              <div
                className="sold-out"
                onClick={() =>
                  !pathname?.includes("exchange-order")
                    ? window.open(`${redirctUrl}`, "_blank")
                    : null
                }
              >
                <div className="div">MAKE TO ORDER</div>
              </div>
            ))}
          {Number(stock) <= 0 && (
            <div
              className="sold-out"
              onClick={() =>
                !pathname?.includes("exchange-order")
                  ? window.open(`${redirctUrl}`, "_blank")
                  : null
              }
            >
              <div className="div">MAKE TO ORDER</div>
            </div>
          )}
          {Number(stock) > 0 &&
            location.pathname === "/inventory" &&
            (props.operation === "Add" ||
              props.operation === "Return" ||
              props.operation === "Exchange") && (
              <div className="quantity">
                <div className="label">Qty</div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default Category;

export function VirtualProducts(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useParams();
  const [newData, setNewData] = useState([]);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [paramVal, setParamVal] = useState("");

  const [allLoaded, setAllLoaded] = useState(false); // To track if all items are loaded

  const [productsData, setProductsData] = useState();

  const [
    getProductsMutation,
    { data, isLoading, isFetching, isSuccess, isError, error },
  ] = useGetProductsMutationMutation();
  // =======================================
  const fetchData = async (page, limit) => {
    const data = await getProductsMutation({
      body: {
        attributes: props.attributeFilters,
      },
      page: page,
      limit: limit,
      queryParams: params?.name
        ? `category=${props.category}&netWeight=${props?.sortBy?.value}&stock=${props?.stockvalue} `
        : `${
            params?.searchProductParams
              ? `title=${params?.searchProductParams}&netWeight=${props?.sortBy?.value}&stock=${props?.stockvalue}`
              : `&netWeight=${props?.sortBy?.value}&stock=${props?.stockvalue}`
          }`,
    }).then((res) => {
      if (res?.data?.products) {
        props.setTotalDocs(res.data.totalDoc);
        if (res.data.products.length === 0) {
          setAllLoaded(true);
        }
        return res.data.products;
      }
      if (res.error) {
        console.log(res.error);
      }
    });

    return data;
    // return shuffleArray(data);
  };

  const [items, setItems] = useState([]); // Holds the grid items
  // console.log("total items", items.length);
  const [loading, setLoading] = useState(false); // Loading state
  const limit = 30; // Limit per page
  const observer = useRef(); // To track the 10th item for intersection

  // // Load data on page change
  const loadItems = async (resetPage) => {
    setLoading(true);
    const newItems = (await fetchData(resetPage ? 1 : page, limit)) || []; // Fetch new items based on page
    // setItems((prev) => [...prev, ...newItems]); // Append new items to the list
    // check if  the prev items are present or not only add those which are not present

    setItems((prev) => {
      // Create a Map where the key is the item._id and the value is the item itself
      const map = new Map();

      // Combine prev and newItems arrays
      const combinedItems = [...prev, ...newItems];

      // Iterate over the combined array and set each item in the Map using its _id as the key
      combinedItems.forEach((item) => map.set(item._id, item));

      // Return an array of the values from the Map (which will be unique by _id)
      return Array.from(map.values());
    });
    setLoading(false);
  };

  useEffect(() => {
    resetAll(); // Reset all data when filters change
  }, [
    props.category,
    props?.sortBy?.value,
    params?.searchProductParams,
    props.attributeFilters,
    props?.stockvalue,
  ]);

  useEffect(() => {
    loadItems();
  }, [
    props.category,
    props?.sortBy?.value,
    page,
    params?.searchProductParams,
    props.attributeFilters,
    props?.stockvalue,
  ]);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Skip the first render
      return;
    }
    resetAll(); // Call the function only on subsequent path changes
  }, [location.pathname]);

  const isFirstRenderPage = useRef(true);
  useEffect(() => {
    if (isFirstRenderPage.current) {
      isFirstRenderPage.current = false; // Skip the first render
      return;
    }
    if (props?.sortBy?.value || props?.category) {
      if (!allLoaded) {
        loadItems();
      }
    }
  }, [
    page,
    props.category,
    props?.sortBy?.value,
    params?.searchProductParams,
    props.attributeFilters,
    props?.stockvalue,
  ]);

  // Prevent infinite API calls by checking `allLoaded`
  const lastItemRef = useCallback(
    (node) => {
      if (loading || allLoaded) return; // Stop loading if already fetched everything

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, allLoaded]
  );

  const resetAll = () => {
    if (observer.current) observer.current.disconnect();
    observer.current = null;
    setPage(1);
    setItems([]);
    setAllLoaded(false);
    loadItems(1);
  };

  // =======================================

  useEffect(() => {
    if (isError) {
      console.log(error);
      toast.error(error?.data?.message);
    }
  }, [isError]);

  const totalProducts = productsData?.totalDoc || 0;
  // set props.setTotalDocs to totalDocs
  useEffect(() => {
    props.setTotalDocs(totalProducts);
  }, [totalProducts]);
  useEffect(() => {
    if (productsData) {
      setNewData(productsData);
    }
  }, [productsData]);

  useEffect(() => {
    const footer = document.querySelector(".Footer_Container");
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - footer.clientHeight
      ) {
        if (products.length < totalProducts) {
          setPage((prevPage) => prevPage + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, isSuccess]);

  const breakpointColumnsObj = {
    default: props.gridCount,
    1024: props.gridCount > 5 ? 5 : props.gridCount,
    768: props.gridCount > 4 ? 4 : props.gridCount,
    320: props.gridCount > 2 ? 2 : props.gridCount,
  };

  return (
    <div>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={` px-5 w-auto py-5 flex -ml-5`}
        columnClassName="bg-clip-padding pl-5"
      >
        {items?.map((item, index) => {
          if (index === items.length - 1) {
            return (
              <div ref={lastItemRef} key={index}>
                <ProductCard
                  key={index}
                  isEqualGrid={props.isEqualGrid}
                  product={item}
                  route={"/virtual-tryon"}
                  storeType={"Virtual"}
                  {...props}
                />
              </div>
            );
          } else {
            return (
              <div key={index}>
                <ProductCard
                  key={index}
                  isEqualGrid={props.isEqualGrid}
                  product={item}
                  route={"/virtual-tryon"}
                  storeType={"Virtual"}
                  {...props}
                />
              </div>
            );
          }
        })}
      </Masonry>
      {!items?.length > 0 && !(!isSuccess || loading) ? (
        <div className="no_product_found text-text_dark_3 cormorant-medium">
          Products Coming Soon
        </div>
      ) : null}
      {(!isSuccess || loading) && (
        <div className="w-full h-screen">
          <Skeleton className="w-full h-full" />
        </div>
      )}
    </div>
  );
}

{
  {
    {
      // className={`gap-5 p-5 grid grid-cols-${props.gridCount}`}
      {
        /*
        
             <div
        className="grid gap-5 p-5"
        style={{
          gridTemplateColumns: `repeat(${props?.gridCount}, minmax(0, 1fr))`,
        }}
      >
        {(localStorage.getItem("user") ? items : items?.slice(0, 10)).map( */
      }
      /* <div
        className={` ${
          props?.isEqualGrid
            ? `grid grid-cols-${props?.gridCount}`
            : `columns-${props?.gridCount} `
        } gap-5 p-5`}
        style={{
          // columnCount: `${!props?.isEqualGrid ? `${props?.gridCount}` : ``}`,
          gridColumn:`${props?.gridCount}`
        }}
      > */
    }
    {
      /* <div className={`grid grid-cols-${props?.gridCount} gap-5 p-5`}> */
    }
    {
      /* <div className={` ${props?.gridCount ? "cards_2" : "cards"}`}> */
    }
    /* {products.length > 2 && (
            <Link
              to="/"
              className={`${
                props?.gridCount
                  ? "category-banner-1_2 card"
                  : "card category-banner-1"
              } `}
            >
              <div className="img-box">
                <LazyImageLoader
                  imgSrc={mainBgImg}
                  imgAlt="Best Selling Frames"
                  imgObjectFit={"cover"}
                />
              </div>
            </Link>
          )} */
  }
  {
    /* {products.length > 16 && (
            <Link to="/" className="card category-banner-2">
              <div className="img-box">
                <LazyImageLoader
                  imgSrc={homeBannerDesktop}
                  imgAlt="Category Banner"
                  imgObjectFit={"cover"}
                />
              </div>
            </Link>
          )} */
  }
  /* <div className="card lg:p-5 emd:p-5 small:p-4 bg-text_light_3">
<div className="top relative">
  {props?.product?.stock > 0 && (
    <div
      style={{ visibility: showNewArrival ? "visible" : "hidden" }}
      className="lato-regular new-arrival-label absolute lg:-top-1.5 lg:-left-7 emd:-top-1.5 emd:-left-7 small:-top-0 small:-left-5 bg-primary  text-white px-4 py-1"
    >
      &nbsp; NEW ARRIVAL &nbsp;
    </div>
  )}

  {props?.product?.stock <= 0 && !showNewArrival && (
    <div className="lato-regular new-arrival-label absolute lg:-top-1.5 lg:-left-7 emd:-top-1.5 emd:-left-7 small:-top-0 small:-left-5 bg-text_dark_3  text-white px-4 py-1">
      &nbsp;MAKE TO ORDER&nbsp;
    </div>
  )}

  {wishListed ? (
    <svg
      onClick={handleWishlist}
      className="pointer filled min-w-[30px] max-w-[30px] min-h-[30px] max-h-[30px]"
      viewBox="0 -960 960 960"
      fill="#5D0D19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="min-w-fit max-w-fit min-h-fit max-h-fit"
        d="M 480 -173.85 L 449.69 -201.23 C 384.41 -260.87 330.41 -311.92 287.69 -354.38 C 244.977 -396.847 211.26 -434.297 186.54 -466.73 C 161.82 -499.163 144.55 -528.51 134.73 -554.77 C 124.91 -581.023 120 -607.433 120 -634 C 120 -684.873 137.283 -727.59 171.85 -762.15 C 206.41 -796.717 249.127 -814 300 -814 C 335.18 -814 368.18 -805 399 -787 C 429.82 -769 456.82 -742.82 480 -708.46 C 503.18 -742.82 530.18 -769 561 -787 C 591.82 -805 624.82 -814 660 -814 C 710.873 -814 753.59 -796.717 788.15 -762.15 C 822.717 -727.59 840 -684.873 840 -634 C 840 -607.433 835.09 -581.023 825.27 -554.77 C 815.45 -528.51 798.18 -499.163 773.46 -466.73 C 748.74 -434.297 715.15 -396.847 672.69 -354.38 C 630.23 -311.92 576.103 -260.87 510.31 -201.23 L 480 -173.85 Z M 480 -501 Z"
        transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
      />
    </svg>
  ) : (
    <svg
      onClick={handleWishlist}
      className="pointer min-w-[30px] max-w-[30px] min-h-[30px] max-h-[30px]"
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#5D0D19"
    >
      <path
        className="min-w-fit max-w-fit min-h-fit max-h-fit"
        d="m480-173.85-30.31-27.38q-97.92-89.46-162-153.15-64.07-63.7-101.15-112.35-37.08-48.65-51.81-88.04Q120-594.15 120-634q0-76.31 51.85-128.15Q223.69-814 300-814q52.77 0 99 27t81 78.54Q514.77-760 561-787q46.23-27 99-27 76.31 0 128.15 51.85Q840-710.31 840-634q0 39.85-14.73 79.23-14.73 39.39-51.81 88.04-37.08 48.65-100.77 112.35Q609-290.69 510.31-201.23L480-173.85Zm0-54.15q96-86.77 158-148.65 62-61.89 98-107.39t50-80.61q14-35.12 14-69.35 0-60-40-100t-100-40q-47.77 0-88.15 27.27-40.39 27.27-72.31 82.11h-39.08q-32.69-55.61-72.69-82.5Q347.77-774 300-774q-59.23 0-99.62 40Q160-694 160-634q0 34.23 14 69.35 14 35.11 50 80.61t98 107q62 61.5 158 149.04Zm0-273Z"
      />
    </svg>
  )}
  {props.product?.quantity > 0 && (
    <div
      className={
        location.pathname === "/inventory" &&
        props.storeType === "In Store"
          ? "count"
          : "count hide"
      }
    >
      {props.product?.quantity}
    </div>
  )}
</div>
<div
  className="pointer overflow-hidden"
  key={props?.product?._id}
  onClick={() =>
    !pathname?.includes("exchange-order")
      ? window.open(`${redirctUrl}`, "_blank")
      : null
  }
>
  <LazyImageLoader
    imgSrc={props.product?.image[0] || dagabengalurulogoPNG}
    imgAlt="product image"
    imgClassName="aspect-square max-h-[50vh] md:hover:scale-[120%] transition-all duration-300"
    imgHeight={"unset"}
  />
</div>
<div className="bottom">
  <div className="text-text_dark_3 text-lg w-[calc(100%)] overflow-hidden whitespace-nowrap text-ellipsis text capitalize">
    {props.product?.name ? (
      <span className="lato-medium">{props.product?.name}</span>
    ) : (
      <Skeleton className="h-full" />
    )}
  </div>
  <div className="text-sm lato-regular">
    Net&nbsp;wt:&nbsp;{props?.product?.netWeight}&nbsp;g
  </div>
  <div className="text-sm lato-regular">
    Gross&nbsp;wt:&nbsp;{props?.product?.grossWeight}&nbsp;g
  </div>
  <span
    className="add_to_bag_text text-primary cursor-pointer lato-bold"
    onClick={() => addCartHandle(false)}
  >
    Add to Bag
  </span>
</div>
{props.product?.quantity === 0 ||
  props.product?.quantity === "0" ||
  (Number(props.product?.quantity) <= 0 && (
    <div
      className="sold-out"
      onClick={() =>
        !pathname?.includes("exchange-order")
          ? window.open(`${redirctUrl}`, "_blank")
          : null
      }
    >
      <div className="div">MAKE TO ORDER</div>
    </div>
  ))}
{Number(stock) <= 0 && (
  <div
    className="sold-out"
    onClick={() =>
      !pathname?.includes("exchange-order")
        ? window.open(`${redirctUrl}`, "_blank")
        : null
    }
  >
    <div className="div">MAKE TO ORDER</div>
  </div>
)}
{Number(stock) > 0 &&
  location.pathname === "/inventory" &&
  (props.operation === "Add" ||
    props.operation === "Return" ||
    props.operation === "Exchange") && (
    <div className="quantity">
      <div className="label">Qty</div>
    </div>
  )}
</div>








<div
className={` ${
  props?.isEqualGrid
    ? `grid grid-cols-${props?.gridCount}`
    : `columns-${props?.gridCount} `
} gap-5 p-5`}
style={{
  columnCount: `${!props?.isEqualGrid ? `${props?.gridCount}` : ``}`,
}}
>
{fakeData?.map((item, index) => {
  return (
    <Skeleton
      key={index}
      className="card max-h-[40vh] min-h-[40vh]"
    />
  );
})}
</div>
*/
}
